/**
 * Tooltip branco/com-seta para nós do mock (innerHTML), via data-tpm-tip.
 * Visual alinhado ao GoHoverTooltip.
 * Listas: data-tpm-tip com linhas (\n), data-tpm-tip-list (JSON array)
 * ou cluster multi-OS: data-tpm-tip-cluster (JSON { total, groups }).
 */
const OFFSET = 8;
const PAD = 8;

let tipEl = null;
let arrowEl = null;
let textEl = null;

function ensureTip() {
  if (tipEl) return tipEl;
  tipEl = document.createElement('span');
  tipEl.className = 'go-hover-tip-portal';
  tipEl.setAttribute('role', 'tooltip');
  tipEl.style.visibility = 'hidden';
  tipEl.style.top = '0';
  tipEl.style.left = '0';
  tipEl.style.zIndex = '14030';

  arrowEl = document.createElement('span');
  arrowEl.className = 'go-hover-tip-arrow';
  arrowEl.style.left = '50%';

  textEl = document.createElement('span');
  textEl.className = 'go-hover-tip-text';

  tipEl.appendChild(arrowEl);
  tipEl.appendChild(textEl);
  document.body.appendChild(tipEl);
  return tipEl;
}

function hideTip() {
  if (!tipEl) return;
  tipEl.style.visibility = 'hidden';
  tipEl.classList.remove(
    'go-hover-tip-portal--below',
    'go-hover-tip-portal--wrap',
    'go-hover-tip-portal--list',
    'go-hover-tip-portal--cluster'
  );
}

function parseTipLines(host, text) {
  const rawList = host?.getAttribute?.('data-tpm-tip-list');
  if (rawList) {
    try {
      const arr = JSON.parse(rawList);
      if (Array.isArray(arr)) {
        return arr.map((s) => String(s ?? '').trim()).filter(Boolean);
      }
    } catch {
      /* fallthrough */
    }
  }
  const s = String(text || '');
  if (s.includes('\n')) {
    return s.split('\n').map((line) => line.trim()).filter(Boolean);
  }
  return s ? [s] : [];
}

function parseClusterPayload(host) {
  const raw = host?.getAttribute?.('data-tpm-tip-cluster');
  if (!raw) return null;
  try {
    const data = JSON.parse(raw);
    if (!data || !Array.isArray(data.groups) || !data.groups.length) return null;
    return data;
  } catch {
    return null;
  }
}

function fillClusterTip(payload) {
  tipEl.classList.add(
    'go-hover-tip-portal--list',
    'go-hover-tip-portal--wrap',
    'go-hover-tip-portal--cluster'
  );
  const root = document.createElement('span');
  root.className = 'go-hover-tip-cluster';

  const head = document.createElement('span');
  head.className = 'go-hover-tip-cluster-head';
  const total = Number(payload.total) || payload.groups.reduce((n, g) => n + (g.count || 0), 0);
  head.innerHTML =
    `<span class="go-hover-tip-cluster-total">${total} OS</span>` +
    `<span class="go-hover-tip-cluster-sub">mesmo ponto · clique adiciona todas</span>`;
  root.appendChild(head);

  payload.groups.forEach((g) => {
    const block = document.createElement('span');
    block.className = 'go-hover-tip-cluster-group';

    const title = document.createElement('span');
    title.className = 'go-hover-tip-cluster-client';
    const count = Number(g.count) || (g.osList || []).length;
    title.innerHTML =
      `<span class="go-hover-tip-cluster-client-name"></span>` +
      `<span class="go-hover-tip-cluster-client-count">${count} OS</span>`;
    title.querySelector('.go-hover-tip-cluster-client-name').textContent = g.client || '—';
    block.appendChild(title);

    const chips = document.createElement('span');
    chips.className = 'go-hover-tip-cluster-os';
    (g.osList || []).forEach((os) => {
      const chip = document.createElement('span');
      chip.className = 'go-hover-tip-cluster-os-chip';
      chip.textContent = `#${os}`;
      chips.appendChild(chip);
    });
    block.appendChild(chips);
    root.appendChild(block);
  });

  textEl.replaceChildren(root);
}

function fillTipContent(lines, clusterPayload) {
  textEl.textContent = '';
  textEl.replaceChildren();
  tipEl.classList.remove('go-hover-tip-portal--cluster');
  if (clusterPayload) {
    fillClusterTip(clusterPayload);
    return;
  }
  if (lines.length > 1) {
    tipEl.classList.add('go-hover-tip-portal--list', 'go-hover-tip-portal--wrap');
    const list = document.createElement('span');
    list.className = 'go-hover-tip-list';
    lines.forEach((line) => {
      const item = document.createElement('span');
      item.className = 'go-hover-tip-list-item';
      item.textContent = line;
      list.appendChild(item);
    });
    textEl.appendChild(list);
    return;
  }
  tipEl.classList.remove('go-hover-tip-portal--list');
  textEl.textContent = lines[0] || '';
}

function placeTip(anchor, text, wrap) {
  const tip = ensureTip();
  const cluster = parseClusterPayload(anchor);
  const lines = cluster ? [] : parseTipLines(anchor, text);
  fillTipContent(lines, cluster);
  const forceWrap = Boolean(wrap) || lines.length > 1 || !!cluster;
  tip.classList.toggle('go-hover-tip-portal--wrap', forceWrap);
  tip.style.visibility = 'hidden';
  tip.classList.remove('go-hover-tip-portal--below');

  const rect = anchor.getBoundingClientRect();
  const tipW = tip.offsetWidth;
  const tipH = tip.offsetHeight;

  let left = rect.left + rect.width / 2 - tipW / 2;
  left = Math.min(Math.max(PAD, left), window.innerWidth - tipW - PAD);

  let below = false;
  let top = rect.top - tipH - OFFSET;
  if (top < PAD) {
    top = rect.bottom + OFFSET;
    below = true;
  }

  const anchorCenter = rect.left + rect.width / 2;
  const arrow = Math.min(Math.max(10, anchorCenter - left), tipW - 10);
  arrowEl.style.left = `${arrow}px`;
  tip.classList.toggle('go-hover-tip-portal--below', below);
  tip.style.top = `${top}px`;
  tip.style.left = `${left}px`;
  tip.style.visibility = 'visible';
}

function findTipHost(target, root) {
  if (!target || !root || !root.contains(target)) return null;
  return target.closest?.('[data-tpm-tip]') || null;
}

/**
 * @param {ParentNode} root
 * @returns {() => void} cleanup
 */
export function bindTechnicianPanelDomTips(root) {
  if (!root) return () => {};

  let active = null;

  const onOver = (e) => {
    const host = findTipHost(e.target, root);
    if (!host) return;
    const text = host.getAttribute('data-tpm-tip');
    if (!text) return;
    if (active === host) return;
    active = host;
    placeTip(host, text, host.hasAttribute('data-tpm-tip-wrap'));
  };

  const onOut = (e) => {
    if (!active) return;
    const to = e.relatedTarget;
    if (to && active.contains(to)) return;
    if (to && findTipHost(to, root) === active) return;
    active = null;
    hideTip();
  };

  const onScroll = () => {
    if (!active) return;
    const text = active.getAttribute('data-tpm-tip');
    if (!text) {
      active = null;
      hideTip();
      return;
    }
    placeTip(active, text, active.hasAttribute('data-tpm-tip-wrap'));
  };

  root.addEventListener('mouseover', onOver);
  root.addEventListener('mouseout', onOut);
  window.addEventListener('scroll', onScroll, true);
  window.addEventListener('resize', onScroll);

  return () => {
    root.removeEventListener('mouseover', onOver);
    root.removeEventListener('mouseout', onOut);
    window.removeEventListener('scroll', onScroll, true);
    window.removeEventListener('resize', onScroll);
    active = null;
    hideTip();
  };
}
